import React, { useState, useEffect, useCallback, useRef } from 'react'
import { host } from '../script/variables'
import '../style/AdminPartnersList.css'

// ─── Config ──────────────────────────────────────────────────────────────────
const API_BASE = `${host}/admin/getpartners`
const PAGE_LIMIT = 20

const FILTER_FIELDS = [
  { key: 'name',  label: 'Name',      placeholder: 'Search by name…',  type: 'text'  },
  { key: 'id',    label: 'Partner ID', placeholder: 'Search by ID…',   type: 'text'  },
  { key: 'phone', label: 'Phone',     placeholder: 'Search by phone…', type: 'text'  },
  { key: 'email', label: 'Email',     placeholder: 'Search by email…', type: 'email' },
]

const SOCIAL_LINKS = [
  { key: 'insta',    icon: InstagramIcon, label: 'Instagram' },
  { key: 'linkedin', icon: LinkedInIcon,  label: 'LinkedIn'  },
  { key: 'twitter',  icon: TwitterIcon,   label: 'Twitter'   },
]

// ─── Icons ───────────────────────────────────────────────────────────────────
function InstagramIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
    </svg>
  )
}
function LinkedInIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
      <rect x="2" y="9" width="4" height="12"/>
      <circle cx="4" cy="4" r="2"/>
    </svg>
  )
}
function TwitterIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
    </svg>
  )
}
function SearchIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"/>
      <line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
  )
}
function XIcon({ size = 12 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"/>
      <line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  )
}
function UserIcon({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  )
}
function PhoneIcon({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9a16 16 0 0 0 6 6l1.27-.88a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  )
}
function MailIcon({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
      <polyline points="22,6 12,13 2,6"/>
    </svg>
  )
}
function CakeIcon({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8"/>
      <path d="M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2 1 2 1"/>
      <path d="M2 21h20"/>
      <path d="M7 8v3"/><path d="M12 8v3"/><path d="M17 8v3"/>
      <path d="M7 4a1 1 0 0 0-2 0c0 1 2 3 2 3s2-2 2-3a1 1 0 0 0-2 0z"/>
    </svg>
  )
}
function GenderIcon({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="11" r="4"/>
      <path d="M16 3h5v5"/><path d="M21 3l-5.27 5.27"/>
      <path d="M12 15v6"/><path d="M9 18h6"/>
    </svg>
  )
}
function IDIcon({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="5" width="20" height="14" rx="2"/>
      <line x1="2" y1="10" x2="22" y2="10"/>
    </svg>
  )
}

// ─── Utility ──────────────────────────────────────────────────────────────────
const formatDate = (d) =>
  d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'
const isValidLink = (v) => v && v !== '#'
const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '—')

function getAccountBadgeClass(accounttype) {
  if (accounttype === 'public')  return 'account-badge account-badge--public'
  if (accounttype === 'private') return 'account-badge account-badge--private'
  return 'account-badge account-badge--default'
}

// ─── Avatar ───────────────────────────────────────────────────────────────────
function Avatar({ src, name, size = 56 }) {
  const [err, setErr] = useState(false)
  const initials = name
    ? name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()
    : '?'
  return (
    <div
      className="avatar"
      style={{ width: size, height: size, fontSize: size * 0.3 }}
    >
      {!err && src && src !== '#' ? (
        <img src={src} alt={name} onError={() => setErr(true)} />
      ) : (
        initials
      )}
    </div>
  )
}

// ─── Partner Card ─────────────────────────────────────────────────────────────
function PartnerCard({ partner, animationDelay }) {
  const fullName = `${partner.firstName ?? ''} ${partner.lastName ?? ''}`.trim()
    || partner.displayName
    || '—'
  const activeSocials = SOCIAL_LINKS.filter(s => isValidLink(partner[s.key]))

  return (
    <div
      className="partner-card fade-in-up"
      style={{ animationDelay }}
    >
      {/* Accent line */}
      <div className="partner-card-accent" />

      {/* Header */}
      <div className="partner-card-header">
        <Avatar src={partner.image} name={fullName} size={52} />
        <div className="partner-card-name-block">
          <div className="partner-card-name">{fullName}</div>
          {partner.displayName && partner.displayName !== fullName && (
            <div className="partner-card-displayname">@{partner.displayName}</div>
          )}
          <span className={getAccountBadgeClass(partner.accounttype)}>
            {capitalize(partner.accounttype)}
          </span>
        </div>
      </div>

      {/* Meta grid */}
      <div className="meta-rows">
        <MetaRow icon={<IDIcon />} label="ID"
          value={<span className="meta-row__value--mono">{partner._id}</span>} />
        <MetaRow icon={<MailIcon />}   label="Email"  value={partner.email}             />
        <MetaRow icon={<PhoneIcon />}  label="Phone"  value={partner.phone || '—'}      />
        <MetaRow icon={<GenderIcon />} label="Gender" value={capitalize(partner.gender)}/>
        <MetaRow icon={<CakeIcon />}   label="DOB"    value={formatDate(partner.dob)}   />
      </div>

      {/* Fav dishes */}
      {partner.favdishes?.length > 0 && (
        <div className="fav-dishes">
          <div className="fav-dishes__label">Fav Dishes</div>
          <div className="fav-dishes__list">
            {partner.favdishes.map((d, i) => (
              <span key={i} className="fav-dish-tag">{d}</span>
            ))}
          </div>
        </div>
      )}

      {/* Socials + joined date */}
      {(activeSocials.length > 0 || partner.createdAt) && (
        <div className="partner-card-footer">
          {activeSocials.map(({ key, icon: Icon, label }) => (
            <a
              key={key}
              href={partner[key]}
              target="_blank"
              rel="noopener noreferrer"
              title={label}
              className="social-link"
            >
              <Icon size={14} />
            </a>
          ))}
          <span className="partner-joined-date">
            Joined {formatDate(partner.createdAt)}
          </span>
        </div>
      )}
    </div>
  )
}

function MetaRow({ icon, label, value }) {
  return (
    <div className="meta-row">
      <span className="meta-row__icon">{icon}</span>
      <span className="meta-row__label">{label}</span>
      <span className="meta-row__value">{value}</span>
    </div>
  )
}

// ─── Skeleton Card ────────────────────────────────────────────────────────────
function SkeletonCard() {
  const lineWidths = [100, 80, 90, 70]
  return (
    <div className="skeleton-card">
      <div className="skeleton-block skeleton-block--avatar" />
      {lineWidths.map((w, i) => (
        <div
          key={i}
          className="skeleton-block skeleton-block--line"
          style={{ width: `${w}%` }}
        />
      ))}
    </div>
  )
}

// ─── Filter Bar ───────────────────────────────────────────────────────────────
function FilterBar({ filters, onChange, onClear }) {
  const hasAnyFilter = Object.values(filters).some(Boolean)
  return (
    <div className="filter-bar">
      {FILTER_FIELDS.map(field => (
        <div key={field.key} className="filter-field-wrapper">
          <span className="filter-search-icon">
            <SearchIcon size={13} />
          </span>
          <input
            type={field.type}
            placeholder={field.placeholder}
            value={filters[field.key] || ''}
            onChange={e => onChange(field.key, e.target.value)}
            className="filter-input"
          />
          {filters[field.key] && (
            <button
              className="filter-clear-btn"
              onClick={() => onChange(field.key, '')}
            >
              <XIcon size={12} />
            </button>
          )}
        </div>
      ))}
      {hasAnyFilter && (
        <button className="filter-clear-all-btn" onClick={onClear}>
          Clear all
        </button>
      )}
    </div>
  )
}

// ─── Custom Hook: usePartners ─────────────────────────────────────────────────
// FIX: Accept primitive filter values instead of an object reference to avoid
//      stale-closure and reference-equality issues in dependency arrays.
function usePartners({ name, id, phone, email }) {
  const [partners, setPartners] = useState([])
  const [page, setPage]         = useState(1)
  const [hasMore, setHasMore]   = useState(true)
  const [loading, setLoading]   = useState(false)
  const [error, setError]       = useState(null)
  const [total, setTotal]       = useState(0)
const isFetchingRef = useRef(false)
  // FIX: Reset pagination when any filter primitive changes.
  useEffect(() => {
    setPartners([])
    setPage(1)
    setHasMore(true)
    setError(null)
    isFetchingRef.current = false 
  }, [name, id, phone, email])

  // FIX: Stable fetchPage using AbortController to cancel stale requests.
  //      Depends on primitive filter values — no object reference churn.
  const fetchPage = useCallback(async (pageNum, signal) => {
  if (isFetchingRef.current) return
  isFetchingRef.current = true

  setLoading(true)
  setError(null)

  try {
    const params = new URLSearchParams({ page: pageNum, limit: PAGE_LIMIT })
    if (name)  params.set('name', name)
    if (id)    params.set('id', id)
    if (phone) params.set('phone', phone)
    if (email) params.set('email', email)

    const res = await fetch(`${API_BASE}?${params}`, {
  method: 'GET',
  credentials: 'include',  
  signal                    
})
    const data = await res.json()

    const newItems = data.partners || []

    setPartners(prev => (pageNum === 1 ? newItems : [...prev, ...newItems]))
    setHasMore(newItems.length === PAGE_LIMIT)

  } catch (err) {
    if (err.name !== 'AbortError') setError(err.message)
  } finally {
    setLoading(false)
    isFetchingRef.current = false   // 🔥 unlock
  }
}, [name, id, phone, email])

  // FIX: Each effect run creates its own AbortController so a new filter
  //      change cancels any in-flight request from the previous render.
  useEffect(() => {
    const controller = new AbortController()
    fetchPage(page, controller.signal)
    return () => controller.abort()
  }, [page, fetchPage])

  // FIX: Expose a stable loadMore that guards against concurrent fetches.
  const loadMore = useCallback(() => {
  if (isFetchingRef.current || !hasMore) return
  setPage(p => p + 1)
}, [hasMore])

  return { partners, loading, error, hasMore, total, loadMore }
}

// ─── Main Component ───────────────────────────────────────────────────────────
const PartnersList = () => {
  const [filters, setFilters] = useState({ name: '', id: '', phone: '', email: '' })
  const [debouncedFilters, setDebouncedFilters] = useState(filters)
  const observerRef = useRef(null)
  const sentinelRef = useRef(null)

  // Debounce: wait 400 ms after last keystroke before firing a new request.
  useEffect(() => {
    const t = setTimeout(() => setDebouncedFilters(filters), 400)
    return () => clearTimeout(t)
  }, [filters])

  // FIX: Spread primitives so the hook receives stable values, not an object.
  const { partners, loading, error, hasMore, total, loadMore } =
    usePartners(debouncedFilters)

  const handleFilterChange = (key, value) =>
    setFilters(f => ({ ...f, [key]: value }))
  const handleClearFilters = () =>
    setFilters({ name: '', id: '', phone: '', email: '' })

  // FIX: Only attach IntersectionObserver after initial load completes to
  //      prevent double-fetching page 1 when sentinel is already in view.
  useEffect(() => {
  if (loading) return   // ⛔ block while loading

  observerRef.current?.disconnect()

  if (!sentinelRef.current || !hasMore) return

  observerRef.current = new IntersectionObserver(
    entries => {
      if (entries[0].isIntersecting ) {
        loadMore()
      }
    },
    { rootMargin: '200px' }
  )

  observerRef.current.observe(sentinelRef.current)

  return () => observerRef.current?.disconnect()
}, [hasMore, loadMore, loading])

  return (
    <div className="partners-page">
      {/* Header */}
      {/* <div className="partners-header">
        <div className="partners-title-row">
          <h1 className="partners-title">Partners</h1>
          <span className="partners-count-badge">
            {total > 0 ? total.toLocaleString() : '—'}
          </span>
        </div>
        <p className="partners-subtitle">
          Restaurant owners registered on the platform
        </p>
      </div> */}

      {/* Filters */}
      <FilterBar
        filters={filters}
        onChange={handleFilterChange}
        onClear={handleClearFilters}
      />

      {/* Error */}
      {error && (
        <div className="error-banner">
          Failed to load partners: {error}
        </div>
      )}

      {/* Empty state */}
      {!loading && !error && partners.length === 0 && (
        <div className="empty-state">
          <UserIcon size={48} />
          <div className="empty-state-title">No partners found</div>
          <div className="empty-state-hint">Try adjusting your filters</div>
        </div>
      )}

      {/* Grid */}
      <div className="partners-grid">
        {partners.map((partner, i) => (
          <PartnerCard
            key={partner._id}
            partner={partner}
            animationDelay={`${Math.min(i % PAGE_LIMIT, 9) * 40}ms`}
          />
        ))}

        {/* Skeleton loaders */}
        {loading && Array.from({ length: 6 }).map((_, i) => (
          <SkeletonCard key={`sk-${i}`} />
        ))}
      </div>

      {/* Infinite scroll sentinel */}
      <div ref={sentinelRef} style={{ height: 1 }} />

      {/* End of list */}
      {!hasMore && partners.length > 0 && (
        <div className="end-of-list">
          — {partners.length} of {total} partners —
        </div>
      )}
    </div>
  )
}

export default PartnersList